// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import FirstPanel from "./components/FirstPanel";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <FirstPanel />
              </ProtectedRoute>
            }
          />
          {/* Si tienes otras rutas protegidas, agrégalas aquí */}
        </Routes>
      </div>
    </Router>
  );
};

export default App;
